import { makeVar, useReactiveVar } from '@apollo/client';

export interface IUseVerificationCodeCache {
  createVerificationCodeId: string | undefined;
  setCreateVerificationCodeId: (value: string | undefined) => void;
}

export const verificationCode = makeVar<string | undefined>(undefined);

export const useVerificationCodeCache = (): IUseVerificationCodeCache => {
  const createVerificationCodeId = useReactiveVar(verificationCode);

  const setCreateVerificationCodeId = (value: string | undefined): void => {
    verificationCode(value);
  };

  return {
    createVerificationCodeId,
    setCreateVerificationCodeId,
  };
};
